import BlockType from 'src/enums/blockType';
import EdgeType from 'src/enums/edgeType'; // ➕ added
import { DeckState } from 'src/pages/quotations/views/blocks/context/DeckContextV3';

function validateBlockEdges(state: DeckState) {
	const deckboxes = state.blocks.filter((blk) => blk.type == BlockType.DECKBOX);
	const landings = deckboxes.flatMap((dk) => dk.landings);
	const stairs = deckboxes.flatMap((dk) => dk.stairs);
	const bumpouts = deckboxes.flatMap((dk) => dk.bumpouts);

	const allBlocks = [...deckboxes, ...landings, ...stairs, ...bumpouts];

	let errorTitle: string | null = null;
	let error: string | null = null;

	for (const block of allBlocks) {
		if (!block?.edges) continue;
		for (const edge of block.edges) {
			if (!edge.segments) continue;
			const attachedSegment =
				block.type === BlockType.STAIR
					? edge.segments.find(
							(seg) =>
								seg.type === EdgeType.LANDING_ATTACHED ||
								seg.type === EdgeType.BLOCK_ATTACHED
						)
					: null;
			const effectiveLength = attachedSegment?.length ?? edge?.length ?? 0; // ➕ added

			const segmentsLength =
				edge?.segments.reduce((acc, seg) => {
					acc += seg.length;
					return acc;
				}, 0) || 0;

			if ((segmentsLength || 0) > effectiveLength) {
				errorTitle = `${block?.label} ${edge.label} Edge Error`;
				error = `Total segments length (${segmentsLength / 12}ft) exceeds edge length (${(edge?.length || 0) / 12}ft)`;
			}

			if ((segmentsLength || 0) < effectiveLength) {
				errorTitle = `${block?.label} ${edge.label} Edge Error`;
				error = `Total segments length (${segmentsLength / 12}ft) is less than edge length (${(edge?.length || 0) / 12}ft)`;
			}
		}
	}

	return { error, errorTitle };
}

export default validateBlockEdges;
